// extracted by mini-css-extract-plugin
export var container = "_p0-0";
export var dotAnimation = "_p0-2";
export var dotsLoading = "_p0-1";